import script from "./FaqDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqDialog.vue?vue&type=script&setup=true&lang=js"

import "./FaqDialog.vue?vue&type=style&index=0&id=04291f98&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04291f98"]])

export default __exports__